import { useForm } from "react-hook-form";
import { Grid } from "@mui/material";
import DrawerCM from "components/shared/Drawer";
import Toast from "helper/toast";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import StackCm from "components/shared/StackCm";
import { StyledGlBtn } from "styles/globals";
import TextFieldCm from "components/shared/TextField";
import { useCallback } from "react";
import { useEffect } from "react";
import { getIndexHeaderRequest, updateIndexHeaderRequest } from "api/indexHeader";

export default function IndexHeader() {
  const { request, loading} =
    useHttp(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();


  const onSubmit = async (data) => {
    const res = await request({
      url: () => updateIndexHeaderRequest(
        {
          ...data
        },
      ),
    });
    if (res) {
      Toast({ type: "success" });
      reset();
      getIndexHeader()
    }
  };

  const getIndexHeader = useCallback(async () => {
    const res = await request({
      url: getIndexHeaderRequest,
    });
    if (res) {
      reset({
        title: res.title || "",
        link: res.link || "",
        text: res.text || "",
      });
    }
  }, []);

  useEffect(() => {
    getIndexHeader();
  }, [getIndexHeader]);

  return (
    <DrawerCM title="">
      {loading ? (
        <LoadingCM />
      ) : (
        <Grid container>
          <StackCm title="فیلد ها">
            <Grid container>
              <Grid item sm={6} xs={12} p={1.5}>
                <TextFieldCm
                  label="عنوان"
                  id="title"
                  register={register}
                  errors={errors}
                />
              </Grid>
              <Grid item sm={6} xs={12} p={1.5}>
                <TextFieldCm
                  label="لینک"
                  id="link"
                  register={register}
                  errors={errors}
                />
              </Grid>
              <Grid item xs={12} p={1.5}>
                <TextFieldCm
                  label="توضیحات"
                  id="text"
                  register={register}
                  errors={errors}
                  rows={5}
                />
              </Grid>
            </Grid>
            <StyledGlBtn
              onClick={handleSubmit(onSubmit)}
              color={"success"}
              title="ثبت"
            />
          </StackCm>
        </Grid>
      )}
    </DrawerCM>
  );
}
